import { defineRouting } from "next-intl/routing";
import { defaultLocale, locales } from "./config";

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: {
    mode: "as-needed",
    prefixes: {
      "zh-CN": "/zh-cn",
      "zh-TW": "/zh-tw",
    },
  },
});
